module.exports = __webpack_public_path__ + "03_long_gold.e76a6de5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/03_long_gold.png
// module id = aJNe
// module chunks = 0